import { createStyles } from '@mui/styles';

import { Theme } from '../../styles/theme';

const styles = (theme: Theme) =>
  createStyles({
    footer: {
      alignItems: 'center',
      width: '100%',
      justifyContent: 'space-between',
    },
    footerItem: {
      margin: theme.spacing(1),
    },
    logoWrapper: {
      width: '96px',
      height: 'auto',
    },
    placeIconButton: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      marginRight: theme.spacing(1),
    },
    divider: {
      margin: theme.spacing(2),
      background: theme.colors.beige,
      width: '1px',
      height: '40%',
      borderRadius: '2px',
    },
  });

export default styles;
